// React
import { useMemo } from 'react';

// Components
import OutputScreen15 from '../components/v15/Calculator';
import OutputScreen14 from '../components/v14/Calculator';
import OutputScreen13 from '../components/v13/Calculator';
import OutputScreen12 from '../components/v12/Calculator';
import OutputScreen10 from '../components/v10/Calculator';
import OutputScreenDefault from '../components/v-default/Calculator';

type OutputScreenComponent = typeof OutputScreen14

function useCalculatorByVersion(version: string | undefined): [OutputScreenComponent] {
  const v = useMemo(() => parseInt(version?.replaceAll('v', '') || '0'), [version]);

  if (v === 15) {
    return [OutputScreen15];
  }
  else if (v === 14) {
    return [OutputScreen14];
  }
  else if(v === 13) {
    return [OutputScreen13];
  }
  else if(v === 12) {
    return [OutputScreen12];
  }
  else if(v === 10) {
    return [OutputScreen10];
  }
   else {
    return [OutputScreenDefault];
  }
}

export default useCalculatorByVersion;
